import { render, staticRenderFns } from "./UserForgot.vue?vue&type=template&id=3e06414e&"
import script from "./UserForgot.vue?vue&type=script&lang=js&"
export * from "./UserForgot.vue?vue&type=script&lang=js&"
import style0 from "./UserForgot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports